import React from 'react';
import DataTable from 'components/data-table';
import {
  RowItemListOrganizationPeriodical,
  RowItemListAttachReceptionPeriodical} from 'modules/reception-periodical/datatable/detail';
import {Link, browserHistory} from 'react-router';
import { connect } from 'react-redux';
import { Reception } from 'api';
import moment from 'moment';
import { header } from 'constants/table';
import { API_URL } from 'constants/config';
import {CheckPermission} from 'modules/login/CheckPermission';
import {TextMessage, Text} from 'components/tt-forms/common';
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinCoQuanDaGiaiQuyet,
  ThongTinNguoiUyQuyen
} from 'modules/letter-information/letter-detail';
import {MasterLayout} from 'layout';

class DetailReceptionPeriodical extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      donViPhoiHopStr: '',
      closeOnSelection: true,
      tenLoaiDonThu: '',
      tenHuongGiaiQuyet: '',
      tenLoaiDoiTuong: '',
      tenLoaiDoiTuongKT: '',
      dataLoaiNguoiDD: [],
      hinhThucGiaiQuyetData: [],
      tableLoading: true,
      detail: {
        canBoTiepDanInfo: {
          hoVaTen: ''
        },
        coQuanToChucTiepDanSTCD: [],
        donSTCD: {
          listNguoiDungDon: [],
          nguoiDuocUyQuyen: {
            chucVu:'',
            diaChiCoQuan: '',
            luatSu: '',
            ngayCapTheLuatSu: '',
            noiCapTheLuatSu: '',
            phanLoaiCongDan: '',
            soDienThoai: '',
            soTheLuatSu: '',
            tenCoQuan: '',
            coUyQuyen: false,
            danTocCongDan: {
              ten: ''
            },
            diaChi: '',
            gioiTinh: true,
            hoVaTen: '',
            ngayCap: '',
            ngaySinh: '',
            noiCapCMNDInfo: {
              ten: ''
            },
            phuongXaCongDan: {
              ten: ''
            },
            quanHuyenCongDan: {
              ten: ''
            },
            quocTichCongDan: {
              ten: ''
            },
            soCMNDHoChieu: '',
            tinhThanhCongDan: {
              ten: ''
            },
            toThon: ''
          },
          listTaiLieuBangChung: [],
          listTaiLieuBangChungLuatSu: [],
          listTaiLieuVanThu: [],
          loaiDon: '',
          loaiDoiTuong: '',
          loaiNguoiDungDon: '',
          linhVucDonThuDon: {
            ten: ''
          },
          linhVucDonThuChiTietDon: {
            ten: ''
          },
          chiTietLinhVucDonThuChiTietDon: {
            ten: ''
          },
          noiDung: '',
          coQuanDaGiaiQuyetDon: {
            ten: '',
            capCoQuanQuanLyInfo: {
              ten: '',
            }
          },
          thamQuyenGiaiQuyetInfo: {
            ten: ''
          },
          lanGiaiQuyet: '',
          hinhThucDaGiaiQuyet: '',
          huongGiaiQuyetDaThucHien: '',
          coThongTinCoQuanDaGiaiQuyet: true,
        },
        ghiChuXuLy: '',
        huongGiaiQuyetTCDLanhDao: '',
        huongXuLy: '',
        huongXuLyText: '',
        ketQuaGiaiQuyet: '',
        loaiTiepDan: '',
        ngayTiepDan: new Date(),
        noiDungTiepCongDan: '',
        thoiHan: '',
        trangThaiKetQua: '',
        yKienXuLy: '',
        donViChuTriInfo: {
          ten: ''
        },
        danhSachDonViPhoiHops: []
      },
      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: [],
      listTaiLieuVanThu: []
    }
  }

  componentDidMount() {
    this.getDetail();
    this.getSoTiepCongDanInfo(this.props.params.id);
  }

  getDonInfo(inputId) {
    Reception.actions.getDonInfo.request({ id: inputId }).then(res => {
      if (res.data) {
        this.setState({
          listTaiLieuBangChung: [...res.data.listTaiLieuBangChung, ...res.data.listTaiLieuBangChungLuatSu],
          dataDoanDiCung: res.data.listDoanDiCung,
          dataNguoiDuocUyQuyen: res.data.nguoiDuocUyQuyen || []
        });
      }
    });
  }

  getSoTiepCongDanInfo(inputId) {
    Reception.actions.getSoTiepCongDanInfo.request({ id: inputId }).then(res => {
      if (res.data) {
        this.setState({
          listTaiLieuVanThu: res.data.listTaiLieuVanThu
        });
      }
    });
  }

  getDetail() {
    this.setState({
      tableLoading: true
    });
    Reception.actions.getDetailReception.request({id: this.props.params.id}).then(res => {
      if (res.data) {
        let state = this.state;
        this.getDonInfo(res.data.donSTCD.donId);
        state.detail = res.data;
        state.data = res.data.donSTCD;
        state.loaiNguoiDungDon = res.data.donSTCD.loaiNguoiDungDon || '';
        state.dataNguoiDungDon = res.data.donSTCD.listNguoiDungDon || [];
        state.loaiDon = res.data.donSTCD.loaiDonText || '';
        state.loaiDonGiaTri = res.data.donSTCD.loaiDon || '';
        state.loaiDoiTuong = res.data.donSTCD.loaiDoiTuongInfo || '';
        state.linhVuc =  res.data.donSTCD.linhVucDonThuDon.ten || '';
        state.linhVucChiTiet = (res.data.donSTCD.linhVucDonThuDon && res.data.donSTCD.linhVucDonThuChiTietDon) ? res.data.donSTCD.linhVucDonThuChiTietDon.ten : '';
        state.linhVucChiTietSub = (res.data.donSTCD.linhVucDonThuDon && res.data.donSTCD.linhVucDonThuChiTietDon && res.data.donSTCD.chiTietLinhVucDonThuChiTietDon) ? res.data.donSTCD.chiTietLinhVucDonThuChiTietDon.ten :  '';
        state.noiDung = res.data.donSTCD.noiDung || '';
        state.dataCoQuanDaGiaiQuyet = (res.data.donSTCD.coThongTinCoQuanDaGiaiQuyet && res.data.donSTCD.coQuanDaGiaiQuyetDon) ? res.data.donSTCD.coQuanDaGiaiQuyetDon : {};

        state.tableLoading = false;
        if (res.data.danhSachDonViPhoiHops) {
          let names = [];
          res.data.danhSachDonViPhoiHops.map((item) => {
            names.push(item.ten);
          });
          state.donViPhoiHopStr = names.join(', ');
        }
        state.linhVucChiTietKhac = (res.data.donSTCD && res.data.donSTCD.linhVucChiTietKhac) ? res.data.donSTCD.linhVucChiTietKhac : '';
        this.setState({ ...state });
      }
    });
  }

  handleExport() {
    let diaChi = '';
    let data = this.state.detail.donSTCD.listNguoiDungDon[0];

    if (data.diaChi) {
      diaChi = diaChi + data.diaChi
    }
    if (data && data.toThon) {
      if (data.diaChi) {
        diaChi = diaChi + ", " + data.toThon
      } else {
        diaChi = diaChi + data.toThon
      }
    }
    if (data && data.phuongXaCongDan) {
      if (data.diaChi || data.toThon) {
        diaChi = diaChi + ", " + data.phuongXaCongDan.ten
      } else {
        diaChi = diaChi + data.phuongXaCongDan.ten
      }
    }
    if (data && data.quanHuyenCongDan) {
      if (data.diaChi || data.phuongXaCongDan) {
        diaChi = diaChi + ", " + data.quanHuyenCongDan.ten
      } else {
        diaChi = diaChi + data.quanHuyenCongDan.ten
      }
    }
    if (data && data.tinhThanhCongDan) {
      if (data.diaChi || data.quanHuyenCongDan) {
        diaChi = diaChi + ", " + data.tinhThanhCongDan.ten;
      } else {
        diaChi = diaChi + data.tinhThanhCongDan.ten;
      }
    }

    let URL = String(API_URL) + "/soTiepCongDans/inPhieuHen?"
    + "hoVaTen=" + (data.hoVaTen ? data.hoVaTen : '...')
    + "&chucVu=" + (this.props.userInfo.chucVu ? this.props.userInfo.chucVu : '...')
    + "&soCMNDHoChieu=" + (data.soCMNDHoChieu ? data.soCMNDHoChieu : '...')
    + "&ngayCap=" + (data.ngayCap ? moment(data.ngayCap).format('DD/MM/YYYY') : "...")
    + "&noiCap=" + (data.noiCapCMNDInfo ? data.noiCapCMNDInfo.ten : "...")
    + "&diaChi=" + (diaChi ? diaChi : '...')
    + "&donViXuLyId=" + this.props.userInfo.donViId
    + "&noiDung=" + this.state.detail.donSTCD.noiDung
    + "&diaDiemTiepCongDan=" + (this.state.detail.diaDiemGapLanhDao || '...')
    + "&thoiGianTiepCongDan=" + (this.state.detail.ngayTiepDan ? moment(this.state.detail.ngayTiepDan).format('HH:mm') : "...")
    + "&ngayHenTiepCongDan=" + (this.state.detail.ngayTiepDan ? moment(this.state.detail.ngayTiepDan).format('DD/MM/YYYY') : "...")
    window.open(URL, "_self");
  }

  render() {
    let isDinhKy = this.props.route.type == 'dinhKy' ? true : false;
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div id="page" className="detail-reception-periodical panel-page">
        <div className="center">
          <div className="back-foward">
            <Link onClick={browserHistory.goBack} title="" >Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-detail">{isDinhKy ? 'Chi tiết cuộc tiếp định kỳ của lãnh đạo' : 'CHI TIẾT CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO'}</h2>
          </div>
          <div className="main_page">
            <form className="form">
              <div className="wrapper_box">
                <div className="page-wrapper mt0">
                  <div className="box-items">
                    <div className="rows">
                      <TextMessage className="col-input" label="Lãnh đạo tiếp:" value={this.state.detail.canBoTiepDanInfo.hoVaTen} />
                      <TextMessage className="col-input" label="Ngày tiếp:" value={moment(this.state.detail.ngayTiepDan).format('DD/MM/YYYY - HH:mm')} />
                      <TextMessage className="col-input" label="Địa điểm:" value={this.state.detail.diaDiemGapLanhDao} />
                    </div>
                  </div>
                </div>
                {
                  this.state.detail.coQuanToChucTiepDanSTCD.length ?
                    <div className="page-wrapper pb5 pl10 pr10">
                      <div className="box-items">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12 pl15">
                              <h3>Danh sách cơ quan, các đơn vị cùng tham gia tiếp công dân</h3>
                            </div>
                            <DataTable
                              header = {header.detailReceptionPeriodical.organization}
                              dataList = {this.state.detail.coQuanToChucTiepDanSTCD}
                              hidePagination={true}
                              tableLoading={this.state.tableLoading}>
                              <RowItemListOrganizationPeriodical/>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  :''
                }
                <div className="page-wrapper">
                  <ThongTinNguoiDungDon
                    title="Thông tin người đứng đơn/Vụ việc"
                    parent={this.state}
                  />
                </div>

                {this.state.data.coUyQuyen ? (
                  <div className="page-wrapper">
                    <div className="box-items no-border">
                      <ThongTinNguoiUyQuyen
                        title="Thông tin người được ủy quyền"
                        parent={this.state}
                      />
                    </div>
                  </div>
                ) : ''}
                <div className="page-wrapper">
                  <div className="box-items no-border">
                    <ThongTinDonVuViec
                      title="Thông tin đơn/Vụ việc"
                      isOpen = {true}
                      parent = {this.state}
                    />
                  </div>
                </div>
                {
                  this.state.data.coThongTinCoQuanDaGiaiQuyet ?
                    <div className="page-wrapper">
                      <div className="box-items no-border">
                        <ThongTinCoQuanDaGiaiQuyet
                          title="Thông tin cơ quan đã giải quyết"
                          isOpen={true}
                          parent={this.state}
                        />
                      </div>
                    </div>
                  : ''
                }
                {
                  this.state.data.trangThaiYeuCauGapLanhDao ?
                    <div className="page-wrapper">
                      <div className="box-items no-border">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Ý kiến lãnh đạo</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form">
                          <div className="rows">
                            <Text
                              className="col-input"
                              label="Thời gian:"
                              value={this.state.data.ngayTao ? moment(this.state.data.ngayTao).format('DD/MM/YYYY'): ''} />

                            <Text
                              className="col-input"
                              label="Ý kiến lãnh đạo:"
                              value={this.state.data.trangThaiYeuCauGapLanhDaoInfo ? this.state.data.trangThaiYeuCauGapLanhDaoInfo.ten : ''} />

                            <Text
                              className="col-100"
                              label="Lý do:"
                              value={this.state.data.lyDoThayDoiTTYeuCauGapLanhDao || ''} />

                          </div>
                        </div>
                      </div>
                    </div>
                  :''
                }
                <div className="page-wrapper pl10 pr10">
                  <div className="box-items no-border">

                      <div className="rows">
                        <div className="col-12 title pl15">
                          <h3>Thông tin xử lý lượt tiếp công dân</h3>
                        </div>
                        <TextMessage className="col-12 pl15" label="Hướng xử lý:" value={this.state.detail.huongGiaiQuyetTCDLanhDaoStr} />
                        <TextMessage className="col-12 pl15" label="Ý kiến xử lý:" value={this.state.detail.yKienXuLy} />
                        {
                          this.state.detail.huongGiaiQuyetTCDLanhDao == 'CHO_GIAI_QUYET' ?
                            <div className="pl10">
                              {/* <TextMessage className="col-input" label="Đơn vị chủ trì:"
                                value={this.state.detail.donViChuTriInfo.ten} /> */}
                              {/* <TextMessage className="col-input auto" label="Đơn vị phối hợp:"
                                value={this.state.donViPhoiHopStr} /> */}
                              <Text label='Hạn xử lý:' red={true} value={this.state.detail.ngayBaoCaoKetQua ? moment(this.state.detail.ngayBaoCaoKetQua).format('DD/MM/YYYY') : ''}/>
                            </div>
                          : null
                        }
                        {
                          this.state.listTaiLieuVanThu.length ?
                            <div className="title">
                              <div className="col-12 pl15">
                                <h3>Danh sách văn bản xử lý</h3>
                              </div>
                              <DataTable
                                header = {header.detailReceptionPeriodical.attach}
                                dataList = {this.state.listTaiLieuVanThu}
                                hidePagination={true}
                                tableLoading={this.state.tableLoading}>
                                <RowItemListAttachReceptionPeriodical/>
                              </DataTable>
                            </div>
                          : null
                        }
                      </div>

                  </div>
                </div>
              </div>
              <div className="box-bottom">
                {
                  !this.state.detail.hoanThanhTCDLanhDao && !isDinhKy &&
                    <Link className="btn-action btn-print btn-print-left" onClick={this.handleExport.bind(this)}>
                      <span>Tải giấy biên nhận</span>
                    </Link>
                }
                {
                  isDinhKy ?
                    <Link to="/tiep-cong-dan/dinh-ky/" className="btn-action btn-close">
                      <span>Đóng</span>
                    </Link>
                  :
                    <Link to="/tiep-cong-dan/dot-xuat/" className="btn-action btn-close">
                      <span>Đóng</span>
                    </Link>
                }

                {
                  CheckPermission('SOTIEPCONGDAN_SUA') && !this.state.detail.hoanThanhTCDLanhDao && !this.state.detail.donSTCD.dangGiaoKTDX ?
                    (
                      isDinhKy ?
                        <Link className="btn-action btn-edit" to={`/tiep-cong-dan/lanh-dao/dinh-ky-chinh-sua/${this.props.params.id}`}>
                          <span>Sửa</span>
                        </Link>
                      :
                        <Link className="btn-action btn-edit" to={`/tiep-cong-dan/lanh-dao/dot-xuat-chinh-sua/${this.props.params.id}`}>
                          <span>Sửa</span>
                        </Link>
                    )
                  : null
                }
              </div>
            </form>
          </div>
        </div>
      </div>
      </MasterLayout>
    );
  }
}

DetailReceptionPeriodical.defaultProps = {
  loaiDonThu: [],
  loaiDoiTuong: [],
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuong: state.duLieuHeThong.loaiDoiTuong,
  };
}

export default connect(bindStateToProps)(DetailReceptionPeriodical);



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/detail-reception-periodical/DetailReceptionPeriodical.jsx